import React from 'react';
import cn from 'classnames';
import {
  Section as ElementSection,
  FormSection,
  ListInfo,
} from 'views/pages/ClientDetail/components/Elements';
import { ZIP_CODE_NUMBER_FIELD } from 'helper/const';
import { useOptions } from 'helper/hooks';
import InputItem from 'views/pages/ClientDetail/components/InputItem';
import { PROFILE_OBJ_KEYS } from '../../constants';
import classes from './Section.module.scss';
import { useWatch } from 'antd/es/form/Form';

const Profile = ({ className, isEdit, form, data, disabled }) => {
  const { stateOptions } = useOptions();
  const isSameAsPhysical = useWatch('is_same_as_physical', form);

  return (
    <div className={cn(classes.profileSection, className)}>
      <ElementSection className={classes.elSection}>
        {isEdit ? (
          <FormSection>
            <InputItem
              name={'address'}
              label="Physical Address"
              form={form}
              addressField
              disabled={disabled}
            />
            <InputItem
              name={'apt'}
              label="Apt."
              form={form}
              aptField
              disabled={disabled}
            />
            <InputItem
              name={'city'}
              label="City"
              form={form}
              addressGroupField
              disabled={disabled}
            />
            {/* <InputItem
              name={'county'}
              label="County"
              form={form}
              addressGroupField
              disabled={disabled}
            /> */}
            <InputItem
              name={'state_id'}
              label="State"
              form={form}
              type="select"
              options={stateOptions}
              addressGroupField
              disabled={disabled}
            />
            <InputItem
              name={'zip_code'}
              label="Zip Code"
              form={form}
              type="number"
              mask={ZIP_CODE_NUMBER_FIELD.MASK}
              placeholder={ZIP_CODE_NUMBER_FIELD.PLACEHOLDER}
              addressGroupField
              disabled={disabled}
            />
            <InputItem
              name={'is_primary'}
              label="Primary Address"
              form={form}
              type="checkbox"
              fullWidth
            />
            <InputItem
              name={'is_same_as_physical'}
              label="Mailing address same as physical address"
              form={form}
              type="checkbox"
              fullWidth
              disabled={disabled}
            />
            {(isSameAsPhysical || []).length === 0 && (
              <>
                <InputItem
                  name={'mailing_address'}
                  label="Mailing Address"
                  form={form}
                  addressField
                  disabled={disabled}
                />
                <InputItem
                  name={'mailing_apt'}
                  label="Apt."
                  form={form}
                  aptField
                  disabled={disabled}
                />
                <InputItem
                  name={'mailing_city'}
                  label="City"
                  form={form}
                  addressGroupField
                  disabled={disabled}
                />
                {/* <InputItem
                  name={'mailing_county'}
                  label="County"
                  form={form}
                  addressGroupField
                  disabled={disabled}
                /> */}
                <InputItem
                  name={'mailing_state_id'}
                  label="State"
                  form={form}
                  type="select"
                  options={stateOptions}
                  addressGroupField
                  disabled={disabled}
                />
                <InputItem
                  name={'mailing_zip_code'}
                  label="Zip Code"
                  form={form}
                  type="number"
                  mask={ZIP_CODE_NUMBER_FIELD.MASK}
                  placeholder={ZIP_CODE_NUMBER_FIELD.PLACEHOLDER}
                  addressGroupField
                  disabled={disabled}
                />
              </>
            )}
          </FormSection>
        ) : (
          <ListInfo objKeys={PROFILE_OBJ_KEYS} data={data} />
        )}
      </ElementSection>
    </div>
  );
};

export default Profile;
